var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningCircle = function SvgWarningCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.128a4.875 4.875 0 1 1 0 9.75 4.875 4.875 0 0 1 0-9.75m0 10.875a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0-9a.56.56 0 0 0-.562.562V7.19a.561.561 0 1 0 1.125 0V4.565A.56.56 0 0 0 7 4.003m.75 5.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0"
  })));
};
export default SvgWarningCircle;